import React, { useState } from 'react';
import { Toast } from './Toast';

interface CopyableIdProps {
    value: string;
    className?: string;
}

/** Renders a value that copies itself to the clipboard on click, without
 * triggering a parent row/card's own onClick (e.g. opening a details drawer). */
export const CopyableId: React.FC<CopyableIdProps> = ({ value, className }) => {
    const [copied, setCopied] = useState(false);

    const handleClick = async (e: React.MouseEvent) => {
        e.stopPropagation();
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
        } catch {
            /* clipboard write blocked (e.g. insecure context) — silently ignore */
        }
    };

    return (
        <>
            <span
                onClick={handleClick}
                title="Click to copy"
                className={`cursor-pointer hover:underline decoration-dotted underline-offset-2 ${className ?? ''}`}
            >
                {value}
            </span>
            {copied && <Toast message="Copied to clipboard" type="success" onDismiss={() => setCopied(false)} />}
        </>
    );
};
